import { isEqual } from "lodash"

export function scrollToMap() {
	let el = document.getElementById("pipsy__map")
	if (el) {
		const y = el.getBoundingClientRect().top + window.pageYOffset - 40
		window.scrollTo({ top: y, behavior: "smooth" })
	}
}

export function formatPhoneNumber(phoneNumberString) {
	var cleaned = ("" + phoneNumberString).replace(/\D/g, "")
	var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
	if (match) {
		return "(" + match[1] + ") " + match[2] + "-" + match[3]
	}
	return null
}

export async function fireEvent(obj, last, set, d) {
	// Last and Set were put in place because rc-slider would strangely send duplicate events.  Happened when you'd change a slider, then go to another tab, then back...on the 2nd+ tries.  Was weird. May be related to this: https://github.com/react-component/slider/issues/492
	try {
		if (!isEqual(obj, last)) {
			let ev = new Event("pipsy__filter")
			ev.pipsy__type = obj.type
			ev.pipsy__data = obj.data
			ev.pipsy__name = obj.name
			if(obj?.formType) ev.pipsy__formType = obj.formType
			document.dispatchEvent(ev)
		}
		if(set)	set(obj)
	} catch (e) {
		console.error(e)
	}
	// Analytics
	try {
		let e = event
		// This is for events like formsubmission where it's a manual trigger event, not a button click.
		let overrides = ["formSubmission"]
		if(overrides.includes(obj.type)) {
			e = {
				type: obj.type,
				target: {
					id: obj.type
				}
			}
		}
		let bads = ["viewFloorplanButton"]
		if(bads.includes(obj.type)) return
		let badEvents = ['blur']
		if(badEvents.includes(e.type)) return
		const eventData = {
			eventType: e.type,
			timestamp: Date.now(),
			data: {
				...obj,
				client: d.pipsyClient,
				property: d.propertyID
			},
			eventDetails: {
				target: e.target.id,
				pageUrl: window.location.href,
				screenSize: `${window.innerWidth}x${window.innerHeight}`,
				// Add other event-specific details that would be hard to fake
				mousePosition: e.type.startsWith("mouse") ? { x: e.clientX, y: e.clientY } : null,
				keyCode: e.type.startsWith("key") ? e.keyCode : null,
			},
		}

		await fetch(`${d.domain}/api/events`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(eventData),
		})
	} catch (error) {
		console.error(error)
	}
}

export function distanceBetween(lat1, lon1, lat2, lon2, unit) {
	if (lat1 == lat2 && lon1 == lon2) {
		return 0
	} else {
		var radlat1 = (Math.PI * lat1) / 180
		var radlat2 = (Math.PI * lat2) / 180
		var theta = lon1 - lon2
		var radtheta = (Math.PI * theta) / 180
		var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
		if (dist > 1) {
			dist = 1
		}
		dist = Math.acos(dist)
		dist = (dist * 180) / Math.PI
		dist = dist * 60 * 1.1515
		if (unit == "K") {
			dist = dist * 1.609344
		}
		if (unit == "N") {
			dist = dist * 0.8684
		}
		return dist
	}
}

export function getDateXDaysAgo(numOfDays, date = new Date()) {
	const daysAgo = new Date(date.getTime())
	daysAgo.setDate(date.getDate() - numOfDays)
	return daysAgo
}

export function hasNumeric(str) {
	if (!str) return false
	return /\d/.test(str)
}
